import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import DATA_FILTERS from 'go/components/common/dataFilters';

export const DropdownOptionFilterListener = (props) => {
  const {contents, filterBy, saveEntitySessionData, contextPathToSave, allowEmpty, propsToPass, ...restProps} = props;
  const [done, setDone] = useState(false);
  const keys = Object.keys(_.get(props.dependencies, '0'));
  const args = [];
  _.each(keys, (key) => args.push(props[key]));
  
  useEffect(() => {
    if (!_.isEmpty(_.get(props, 'refData', []))) {
      const filterRefData = DATA_FILTERS[filterBy](props);
      if (!_.isEmpty(filterRefData) || allowEmpty) {
        saveEntitySessionData(contextPathToSave, filterRefData);
        setDone(true);
      }
    }
  }, [...args, props.token]);
  const propsPassed = _.map(propsToPass, p => ({ [p]: _.get(restProps, p) }));
  return (
    <>
      {done
        ? _.map(contents, (entry, index) => {
            return <ContentDispatch config={entry} key={entry.title} {...propsPassed} />;
          })
        : null}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
  };
};

export default connect(
  mapStateToProps,
  null
)(connectDynamic(DropdownOptionFilterListener));
